import * as React from "react";
import styled from "styled-components";

const SvgCross10 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Calque 1" viewBox="0 0 100 100" {...props}>
    <path
      d="M3 3a10.28 10.28 0 0113.56-.86l1 .86L50 35.47 82.47 3A10.27 10.27 0 0197 17.53L64.53 50 97 82.47A10.27 10.27 0 0197.85 96L97 97a10.28 10.28 0 01-13.56.86 11.26 11.26 0 01-1-.86Q66.21 80.79 50 64.53L17.53 97A10.27 10.27 0 013 82.47L35.47 50 3 17.53A10.27 10.27 0 012.15 4z"
      fillRule="evenodd"
    />
  </svg>
);

export default styled(SvgCross10)``;
